// src/App.jsx

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useParams, useLocation } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";

// Page Components
import AdminOrders from "./pages/adminorders";
import Home from "./pages/home";
import Shop from "./pages/shop";
import ProductDetail from "./pages/productdetail";
import Cart from "./pages/cart";
import Checkout from "./pages/checkout";
import About from "./pages/about";
import Contact from "./pages/contact";
import TermsAndConditions from "./pages/terms-and-conditions";
import ShippingPolicy from "./pages/shipping-delivery-&-refund-policy";
import PrivacyPolicy from "./pages/privacy";


// Import Cart Context
import { CartProvider, useCart } from "./context/cartcontext";

// Import Toaster for notifications
import { Toaster } from "react-hot-toast";

// --------------------
// Global Constants (frontend-only)
// --------------------
export const PRIMARY_COLOR = "text-teal-500";
export const ACCENT_BG = "bg-teal-600 hover:bg-teal-500 transition-colors duration-200";
export const LOGO_URL = "/assets/mehartraderslogo.jpeg"; // place your logo in public/assets/

// Wrapper component to pass slug from URL to ProductDetail
const ProductDetailWrapper = () => {
  const { slug } = useParams();
  const { addToCart } = useCart();
  return <ProductDetail slug={slug} onAddToCart={addToCart} />;
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

// --------------------
// Layout Component
// --------------------
function Layout() {
  const { cartItems, updateItemQuantity, removeFromCart } = useCart();

  const totalCartItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <div className="bg-gray-900 min-h-screen font-sans">
      <ScrollToTop />
      <Header totalCartItems={totalCartItems} />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetailWrapper />} />
        <Route
          path="/cart"
          element={
            <Cart
              cart={cartItems}
              onUpdateQuantity={updateItemQuantity}
              onRemoveItem={removeFromCart}
            />
          }
        />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* Admin Orders */}
        <Route path="/admin/orders" element={<AdminOrders />} />

        <Route
          path="*"
          element={
            <div className="min-h-screen pt-32 bg-gray-900 text-white p-8">
              <h1 className="text-4xl text-center">404 - Not Found</h1>
            </div>
          }
        />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />


      </Routes>

      <Footer />
    </div>
  );
}

// --------------------
// App Wrapper with Context
// --------------------
const AppWrapper = () => (
  <Router>
    <CartProvider>
      <Layout />
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
        }}
      />
    </CartProvider>
  </Router>
);

export default AppWrapper;
